import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AvatarState {
    name: string;
    gender: string;
    brainId: string;
    avatarId: string;
    promptKey: string;
    enName: string;
    type: "2d" | "3d";
}
  
  const initialState: AvatarState = {
    name: '',
    gender: '',
    brainId: '',
    avatarId: '',
    promptKey: '',
    enName: '',
    type: "3d",
  };

const avatar = createSlice({
  name: 'avatar',
  initialState,
  reducers: {
    setAvatar: (state, action: PayloadAction<AvatarState>) => {
        state.name = action.payload.name;
        state.gender = action.payload.gender;
        state.avatarId = action.payload.avatarId;
        if (state.brainId !== action.payload.brainId) {
            state.brainId = action.payload.brainId
        }
        state.enName = action.payload.enName;
        state.promptKey = action.payload.promptKey;
        state.type = action.payload.type ?? "3d";
    },
    setBrainId: (state, action: PayloadAction<string>) => {
        state.brainId = action.payload;
    },
  },
});

export const { setAvatar, setBrainId } = avatar.actions;
export const avatarReducer = avatar.reducer;